<template>
  <div class="w-full">
    <div class="grid grid-cols-1 w-full">
      <BaseInput
        ref="fullName"
        type="text"
        label="Nombre completo"
        v-model="form.first_name"
        placeholder="Ej: Valentina María"
        :required="true"
        :disabled="disabled"
        :maxlength="25"
      />
      <BaseInput
        ref="lastName"
        type="text"
        label="Apellidos"
        v-model="form.last_name"
        placeholder="Ej: Jiménez Gonzalez"
        :required="true"
        :disabled="disabled"
        :maxlength="24"
      />
      <BaseSelect
        ref="identificationType"
        label="Tipo de identificación"
        :selectOptions="customIdentificationType"
        v-model="form.identification_type"
        :required="true"
        :disabled="disabled"
      />
      <BaseInput
        ref="identificationNumber"
        type="text"
        label="Número de identificación"
        placeholder="Ej: 1144578546 (sin puntos)"
        v-model="form.identification_number"
        :required="true"
        :identification="form.identification_type"
        :disabled="disabled"
        :maxlength="15"
      />
      <BaseInput
        v-if="!disabled"
        ref="identification_number_confirmation"
        type="text"
        :identification="form.identification_type"
        label="Confirmar número de identificación"
        placeholder="Ej:123456789"
        v-model="form.identification_number_confirmation"
        required="true"
        @click.native.right.prevent
        @copy.native.prevent
        @paste.native.prevent
      />

      <div v-if="!isValidPpt">
        <p class="mt-5 text-xs text-center text-red-500">{{ feedback2 }}</p>
      </div>
      <BaseDate
        ref="birthDate"
        type="text"
        label="Fecha de nacimiento"
        v-model="form.birth_date"
        placeholder="DD/MM/AAAA"
        :disabled="disabled"
        :disabledDate="disabledDate"
      />

      <BaseInput
        ref="phone"
        type="text"
        phoneNumber
        maxlength="15"
        label="Número de teléfono"
        placeholder="Ej: 300404179"
        v-model="form.phone"
        :disabled="disabled"
        required="true"
      />
    </div>
    <div v-if="form.phone !== '' && !validPhone()">
      <p class="mt-5 text-xs text-center text-red-500">{{ feedback }}</p>
    </div>
    <div class="grid grid-cols-1 gap-4 w-full"></div>
    <div class="grid grid-cols-1 gap-4 w-full">
      <BaseRadio
        name="hasEmail"
        id="hasEmail"
        label="¿Tiene correo electrónico?"
        :radioOptions="optionsYN"
        v-model="form.hasEmail"
        required="true"
      />
      <BaseInput
        v-if="form.hasEmail == 1"
        ref="email"
        type="text"
        label="Correo electrónico"
        v-model="form.email"
        placeholder="ejemplo@ejemplo.com"
        required="true"
        autocomplete="username"
        :maxlength="50"
      />
      <BaseInput
        v-if="form.hasEmail == 1"
        ref="email_confirmation"
        type="text"
        label="Confirmar correo electrónico"
        v-model="form.email_confirmation"
        placeholder="ejemplo@ejemplo.com"
        required="true"
        autocomplete="username"
        :maxlength="50"
      />
    </div>
    <BaseInput
      type="text"
      label="Dirección"
      v-model="form.address"
      placeholder="Calle 123 avenida 123"
      :maxlength="50"
      :required="form.hasEmail == 2"
    />
    <BaseSelect
      ref="department"
      id="department"
      label="Seleccione un departamento"
      :selectOptions="formOptions.optionsDepartments"
      v-model="form.departamento_cod"
      :required="form.hasEmail == 2"
    />
    <BaseSelect
      ref="city"
      id="city"
      label="Seleccione un municipio"
      :selectOptions="optionsMunicipalities"
      v-model="form.municipio_cod"
      :required="form.hasEmail == 2"
    />
  </div>
</template>

<script>
import moment from "moment";
export default {
  props: ["disabled"],
  data() {
    return {
      off: "false",
      vv: "",
      feedback: "",
      feedback2: null,
      form: {
        first_name: "",
        last_name: "",
        identification_type: "",
        identification_number: "",
        identification_number_confirmation: "",
        birth_date:"",
        phone: "",
        email: "",
        email_confirmation: "",
        hasEmail: 1,
        departamento_cod: "",
        municipio_cod: "",
        address: "",
      },
      disabledDate: (current) => {
        // Can not select days after today
        return current && current > moment().endOf("day");
      },
      optionsYN: [
        { id: 1, name: "Sí" },
        { id: 2, name: "No" },
      ],
      optionsMunicipalities: []
    };
  },
  created() {
    this.$emit("setForm", {
      ...this.form,
      email: this.form.email.toLowerCase(),
      email_confirmation: this.form.email_confirmation.toLowerCase(),
    });
  },
  methods: {
    validPhone() {
      if (!this.isValidPhone) {
        this.feedback = "Introduzca un número de teléfono válido";

        return false;
      }
      return true;
    },
    validPpt() {
      if (!this.isValidPpt) {
        this.feedback2 = "Introduzca un número de identificacion válido";

        return false;
      }
      return true;
    },
  },
  computed: {
    formOptions: function () {
      return this.$store.state.form;
    },

    isValidPhone: function () {
      if (!this.form.phone) return true;
      if (
        this.form.phone.toString().length >= 7 &&
        this.form.phone.toString().length <= 15
      )
        return true;

      return false;
    },
    isValidPpt: function () {
      if (
        this.form.identification_type != 10 ||
        !this.form.identification_number
      ) {
        return true;
      }
      if (/(?<![.\d])\d+(?![.\d])/.test(this.form.identification_number)) {
        return true;
      }
      return false;
    },
    customIdentificationType: function () {
      return this.$store.state.form?.optionsIdentificationType?.filter(identification => identification.id != 3);
    }
  },
  watch: {
    form: {
      handler: function (newVal, oldVal) {
        if (this.validPhone()) this.$emit("setForm", newVal);
      },
      deep: true,
    },
    form: {
      handler: function (newVal, oldVal) {
        if (this.validPpt()) this.$emit("setForm", newVal);
      },
      deep: true,
    },
    "form.departamento_cod": async function () {
      if (this.form.departamento_cod == "") {
        return;
      }
      this.form.municipio_cod = "";
      let options = await this.$store.dispatch(
        "form/loadMunicipalitiesOptions",
        { department: this.form.departamento_cod }
      );
      this.optionsMunicipalities = options;
    },
  },
};
</script>